import { render, staticRenderFns } from "./ThgClosingCard.vue?vue&type=template&id=bd80a108&scoped=true&"
import script from "./ThgClosingCard.vue?vue&type=script&lang=ts&"
export * from "./ThgClosingCard.vue?vue&type=script&lang=ts&"
import style0 from "./ThgClosingCard.vue?vue&type=style&index=0&id=bd80a108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd80a108",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCheckbox,VForm,VIcon,VRow})
